const POST_LOGIN = "/login"
const POST_LOGOUT = "/logout"

//Roles CRUD
const CALL_GET_ALL_ROLES = "/admin/roles"
const CREATE_ROLE = "/admin/roles"
const CALL_DELETE_ROLE = "/admin/roles"
const CALL_EDIT_ROLE = "/admin/roles"

//Permissions CRUD
const CALL_GET_ALL_PERMISSIONS = "/admin/permissions"
const CREATE_PERMISSION = "/admin/permissions"
const CALL_DELETE_PERMISSION = "/admin/permissions"
const CALL_EDIT_PERMISSION = "/admin/permissions"

//USERS CRUD
const CALL_GET_ALL_ADMIN_USERS = "/admin/users"
const CALL_CREATE_ADMIN_USER = "/admin/users/create"
const CALL_DELETE_USER = "/admin/permissions"
const CALL_EDIT_USER = "/admin/permissions"

//PRODUCTS CRUD
const CALL_GET_ALL_PRODUCTS = "/admin/products"

//SUPPLIERS CRUD
const CALL_GET_ALL_SUPPLIERS = "/admin/suppliers"

//OPERATOR_PRODUCTS CRUD
const CALL_GET_ALL_OPERATOR_PRODUCTS = "/admin/operator-products"

//GET CALLS FOR OPERATOR PRODUCTS
const CALL_GET_ALL_PRODUCT_CHANNELS = "/admin/product-channels"
const CALL_GET_ALL_PRODUCT_CATEGORIES = "/admin/product-categories"

export {
  POST_LOGIN,
  POST_LOGOUT,
  CALL_GET_ALL_ROLES,
  CREATE_ROLE,
  CALL_DELETE_ROLE,
  CALL_EDIT_ROLE,
  CALL_GET_ALL_PERMISSIONS,
  CREATE_PERMISSION,
  CALL_DELETE_PERMISSION,
  CALL_EDIT_PERMISSION,
  CALL_GET_ALL_ADMIN_USERS,
  CALL_CREATE_ADMIN_USER,
  CALL_GET_ALL_PRODUCTS,
  CALL_GET_ALL_SUPPLIERS,
  CALL_GET_ALL_OPERATOR_PRODUCTS,
  CALL_GET_ALL_PRODUCT_CHANNELS,
  CALL_GET_ALL_PRODUCT_CATEGORIES,
}
